import { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { webUrlNode } from "../../../../constants/appInfo";
import HomeworkEditor from "./HomeworkEditor";

import { getQuizDataByQuizId } from "../../../../store/actions/CreateContent/QuizAPI/createNewMockTest";
import FolderFilterCard from "../FolderFilterCard";
import { EyeIcon, GripHorizontal, Pencil, Plus, Trash2 } from "lucide-react";

import contentfolder from "../../../contentImgs/homework.png";
import LinkHwToBatches from "./homeworkGenerator/components/LinkHwToBatches";

export default function HomeworkLibrary({setQuizObject}) {

    const dispatch = useDispatch();  
  
    const currentToken = useSelector((state)=>state?.user?.user?.token);
    const user_email = useSelector((state)=>state?.user?.user?.user_email
   );
   const appId = useSelector((state)=>state?.app?.app?.ID);
   const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
      
      const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
  const [homeworks, setHomeworks] = useState([]);
  const [createHomework, setCreateHomeworks] = useState(false);
  const [hwId, setHwId] = useState(false);
  const [openBatchesPopUp,setOpenBatchesPopUp] =useState(false)
  const [contentId, setContentId] = useState();

  const fetchHomeworks = async () => {

    const res = await axios.get(`${webUrlNode}/api/homework`, {
      params: {
        appToken: AppToken,
        coursePostId: 1
      }
    });

    setHomeworks(res.data.items || []);
  };

  useEffect(() => {
    fetchHomeworks();
  }, []);

  const deleteHomework = async (id) => {

    if(!window.confirm("Delete homework?")) return;

    await axios.delete(`${webUrlNode}/api/homework/${id}`, {
      params:{  appToken: AppToken,}
    });

    fetchHomeworks();
  };
 const fireGetQuizDataByQuizId=(quizObjectID)=>{
   console.log({testName:"",type:"mock",
        postParent:"",userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:"",postId:quizObjectID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken})
    
      const apiData = dispatch(getQuizDataByQuizId({testName:"",type:"mock",
        postParent:"",userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:"",postId:quizObjectID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
        ));
      /* get response as Promise   */
      apiData.then(response => {
        if(response){  
          if(response?.quiz){
            console.log(response)
      setQuizObject(response?.quiz)
      
  
       }
          
       
       
        
      }
    /* resetting Login input Fields */
    
        
    
      }).catch(error => {
     
      
    
        console.error(error);
      });
     
      }
  return (
    <div style={{position:"relative",zIndex:99,padding:"10px"}}>
{createHomework?<HomeworkEditor contentId={contentId} setQuizObject={(hwId)=>fireGetQuizDataByQuizId(hwId)} id={hwId} onClose ={()=>{setCreateHomeworks(false)}} />:""}
      <h2>Homework Library</h2>

<FolderFilterCard  activeCard={true}   icon={6} title ="+ Homework" onClickPopup={()=>{
   setCreateHomeworks(true) ;setHwId(false)
} }  /> 


    {openBatchesPopUp?<LinkHwToBatches homeworkId={hwId} onClose={()=>{setOpenBatchesPopUp(false)}} />:""}

          {homeworks.map(hw => (

<div  key={hw.id} className="courseContentItemOuterHeadActiveSettings" style={{marginTop:"0px",paddingLeft:"10px",}}>
<div className="courseContentItemJustifyContentIcons"><GripHorizontal  strokeWidth={2} absoluteStrokeWidth  size={18} 
 color="#666666" style={{padding:"4px",background:"#ffffff",borderRadius:"5px",cursor:"pointer",cursor: 'move',}}/>
<img     src={contentfolder} 
        alt="selected Img"
   style={{cursor:"pointer",width:"25px",height:"25px",paddingLeft:"5px"
    
   }}/> </div><div className="courseContentItemJustifyContent"> <div className="themeNone "
 style={{fontSize:"15px",color:"#111",fontWeight:"700"}}> 
{hw.title} 
 
      </div></div><div  className="courseContentItemOuterHeadActiveSettingsInn"
 style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>
    <Plus  onClick={()=>{setOpenBatchesPopUp(true);setHwId(hw.id);}}
strokeWidth={2} absoluteStrokeWidth  size={18} 
 color="#666666" style={{padding:"4px",background:"#ffffff",borderRadius:"5px",cursor:"pointer"}}/>
    <EyeIcon  onClick={()=>fireGetQuizDataByQuizId(hw?.contentId)}
strokeWidth={2} absoluteStrokeWidth  size={18} 
 color="#666666" style={{padding:"4px",background:"#ffffff",borderRadius:"5px",cursor:"pointer"}}/>
          

<Pencil onClick={()=>{setCreateHomeworks(true) ; setHwId(hw.id);setContentId(hw?.contentId)} }
strokeWidth={2} absoluteStrokeWidth  size={18} 
 color="#666666" style={{padding:"4px",background:"#ffffff",borderRadius:"5px",cursor:"pointer"}}/>
          
<Trash2   onClick={()=>deleteHomework(hw.id)} strokeWidth={2} absoluteStrokeWidth  size={18} 
 color="#666666" style={{padding:"4px",background:"#ffffff",borderRadius:"5px",cursor:"pointer"}}/> 
         </div>  </div>

          )) }

    </div>
  );
}